/**
 * EmptyState Component
 * Displayed when there are no messages in the chat
 */

import { cn } from '@/lib/utils';
import { ONBOARDING_STEPS } from '../constants';

interface EmptyStateProps {
  username?: string;
  className?: string;
}

export const EmptyState = ({ username = 'there', className }: EmptyStateProps) => {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {/* Greeting */}
      <div className='text-start'>
        <h2 className=' '>Hi, {username}! 👋</h2>
        <h2 className='  '>What are we testing today?</h2>
      </div>

      {/* Onboarding Steps */}
      <div className='max-w-md flex flex-col gap-2.5'>
        {ONBOARDING_STEPS.map((step) => (
          <div key={step.id} className='flex items-center  gap-3'>
            <div className='shrink-0 size-6 bg-gray-100 rounded-full flex items-center justify-center '>
              <step.icon className='fill-gray-950 size-3.5 text-transparent' />
            </div>
            <div className='flex-1 flex items-center'>
              <p className='text-xs text-gray-800'>{step.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
